import type { AppItem } from "@/types/appItem";

export const appItems: AppItem[] = [
  {
    id: "elanco-ai-chat",
    name: "ElancoGPT",
    description:
      "Your AI-powered chatbot, enhanced with Elanco data and approved for business usage.",
    logo: "/LogoElancoGPT.svg",
    url: "https://chat.elanco.ai",
    isExternal: true,
    category: "AI & ML",
    docsUrl:
      "https://chat.elanco.ai/docs?category=overview&document=introduction",
  },
  {
    id: "elanco-ai-translate",
    name: "Elanco Translate",
    description:
      "ElancoTranslate efficiently translates content into 135 languages through an intuitive interface. It seamlessly preserves original document formats and ensures centralized control, customization, and data security for all translations.",
    logo: "/translations-hub.png",
    url: "https://translations.elanco.ai/",
    isExternal: true,
    category: "AI & ML",
  },
];
